import React from "react";

import PropTypes from "prop-types";

import RbControl from "../RbControl";
import RbSelect from "../RbSelect";

const RbSelectControl = React.forwardRef(function RbSelectControl(props, ref) {
  const {
    autoWidth,
    defaultValue,
    displayEmpty,
    IconComponent,
    input,
    inputProps,
    labelWidth,
    MenuProps,
    multiple,
    native,
    onChange,
    onChangeValue,
    onClose,
    onOpen,
    open,
    options,
    SelectDisplayProps,
    SelectProps,
    value,
    variant,
    ...other
  } = props;

  return (
    <RbControl
      ref={ref}
      renderComponent={(params) => (
        <RbSelect
          {...params}
          autoWidth={autoWidth}
          defaultValue={defaultValue}
          displayEmpty={displayEmpty}
          IconComponent={IconComponent}
          input={input}
          inputProps={inputProps}
          labelWidth={labelWidth}
          MenuProps={MenuProps}
          multiple={multiple}
          native={native}
          onChange={onChange}
          onChangeValue={onChangeValue}
          onClose={onClose}
          onOpen={onOpen}
          open={open}
          options={options}
          SelectDisplayProps={SelectDisplayProps}
          value={value}
          variant={variant}
          {...SelectProps}
        />
      )}
      {...other}
    />
  );
});

RbSelectControl.propTypes = {
  autoWidth: PropTypes.bool,
  defaultValue: PropTypes.any,
  displayEmpty: PropTypes.bool,
  IconComponent: PropTypes.any,
  input: PropTypes.any,
  inputProps: PropTypes.object,
  labelWidth: PropTypes.number,
  MenuProps: PropTypes.object,
  multiple: PropTypes.bool,
  native: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  open: PropTypes.bool,
  options: PropTypes.array,
  SelectDisplayProps: PropTypes.object,
  SelectProps: PropTypes.object,
  value: PropTypes.any,
  variant: PropTypes.oneOf(["filled", "outlined", "standard"]),
};

RbSelectControl.defaultProps = {
  autoWidth: undefined,
  defaultValue: undefined,
  displayEmpty: undefined,
  IconComponent: undefined,
  input: undefined,
  inputProps: undefined,
  labelWidth: undefined,
  MenuProps: undefined,
  multiple: undefined,
  native: undefined,
  onChange: undefined,
  onChangeValue: undefined,
  onClose: undefined,
  onOpen: undefined,
  open: undefined,
  options: undefined,
  SelectDisplayProps: undefined,
  SelectProps: undefined,
  value: undefined,
  variant: undefined,
};

export default React.memo(RbSelectControl);
